import { SvgIcon } from '@mui/material';

function PhoneIcon() {
  return (
    <SvgIcon>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_10586_2347)'>
          <path
            d='M8.44105 14.2328C8.41647 14.3551 8.36177 14.4694 8.2819 14.5652C8.20203 14.6611 8.09952 14.7355 7.98364 14.7817L3.45661 16.5072C3.30622 16.5676 3.14034 16.5776 2.98379 16.5357C2.82724 16.4939 2.68845 16.4025 2.58819 16.2752C1.92151 15.4026 1.59446 14.3175 1.66787 13.2217C1.74127 12.126 2.21014 11.0942 2.98726 10.3183C5.37835 7.9272 8.62137 6.58391 12.0029 6.58391C15.3844 6.58391 18.6274 7.92721 21.0185 10.3183C21.7956 11.0942 22.2645 12.126 22.3379 13.2217C22.4113 14.3175 22.0842 15.4026 21.4176 16.2752C21.3173 16.4025 21.1785 16.4939 21.022 16.5357C20.8654 16.5776 20.6995 16.5676 20.5491 16.5072L16.0195 14.779C15.9047 14.7331 15.803 14.6595 15.7236 14.5648C15.6441 14.47 15.5893 14.3571 15.564 14.2361L15.2962 11.135C15.2707 11.0089 15.2128 10.8916 15.1283 10.7946C15.0439 10.6976 14.9356 10.6242 14.8143 10.5815C13.1437 10.0074 10.8375 10.0213 9.16892 10.604C9.04731 10.6473 8.93907 10.7215 8.85491 10.8194C8.77074 10.9173 8.71355 11.0354 8.68898 11.1622L8.44105 14.2328Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_10586_2347'>
            <rect width='24' height='24' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
export default PhoneIcon;
